$('#menu > li.menu-item-has-children > span').on('click', function(){
	var element = $(this);

	if(element.hasClass('active')){
		menuClose(element);
	}else {
		menuOpen(element);

	}
});

// Close the menu when the overlay is clicked
$('main').on('click', function(e){
	if($('main').hasClass('menu-open')){
		menuClose('close');
		removeOverlay();
	}
});

// close the specified menu item or all menu items if the given input is 'close'
function menuClose(element) {
	removeOverlay();
	removeBackgroundBlockHeight();
	if(element == 'close') {
		removeMenuClasses();
	}else{
		element.removeClass('active');
	}
	$('#menu').removeClass('menu-open');
}

// open the item specific menu
function menuOpen(element) {
	$('#menu').addClass('menu-open');
	addOverlay();
	adjustBackgroundBlockHeight(element);
	setTimeout(function() {
	}, 300);
	removeMenuClasses();
		element.addClass('active');
}

// Add a page overlay to disable clicking on the page elements
function addOverlay() {
	$('main').addClass('menu-open');
}

// remove the page overlay
function removeOverlay() {
	$('main').addClass('menu-closing');
	setTimeout(function() {
		$('main').removeClass('menu-open');
		$('main').removeClass('menu-closing');
	}, 300);
}

// Close all menu items
function removeMenuClasses() {
	$('#menu .active, .search-btn.active').removeClass('active');
}

function adjustBackgroundBlockHeight(element) {
	var subMenu = element.next('ul').find('.sub-menu-container');
	$('#background-block').height(subMenu.outerHeight());
}

function removeBackgroundBlockHeight() {
	$('#background-block').height(0);
}


// Close the menu and overlay when the mobile menu is visible
$(window).on('resize',function(){
	if(window.innerWidth < 1151){
		menuClose('close');
		removeOverlay();
	}else{
		if($('body').hasClass('is-active') && $('header').hasClass('is-active')){
			$('body').removeClass('is-active');
			$('header').removeClass('is-active');
		}
	}
});
